<div class="groupForm">
    <div class="label">
      <label for="search-company" [translate]="'SearchCompany.label'"></label>
    </div>
    <mat-form-field appearance="outline">
      <input name="search-company" placeholder="{{'SearchCompany.placeholder' | translate}}" [matAutocomplete]="dqeSearch" matInput #dqeInput [formControl]="researchField" />
      <mat-icon matSuffix>search</mat-icon>
      <mat-autocomplete (optionSelected)="companyChosen($event)" [displayWith]="displayCompleteOption.bind(this)" #dqeSearch="matAutocomplete">
        <mat-option *ngIf="isLoading" class="is-loading">
          <mat-progress-bar mode='indeterminate' color="primary"></mat-progress-bar>
          <span class="mat-caption">{{'SearchCompany.update' | translate}}</span>
        </mat-option>
        <ng-container *ngIf="!isLoading">
          <mat-option class="company-search-result" *ngFor="let company of filteredResearch" [value]="company.searchReference">
            <span>{{company.name}}</span>
            <span>{{company.address}} {{company.codePosal}} {{company.locality}}</span>
          </mat-option>
          <mat-option class="company-no-result" value="">
            <span>{{'SearchCompany.no-results' | translate}}</span>
          </mat-option>
        </ng-container>
      </mat-autocomplete>
    </mat-form-field>
    <mat-spinner *ngIf="companyIsLoading" [diameter]="30" class="spinner"> </mat-spinner>
  </div>